<template>
  <div :class="paginaQuestionarioClassName">
    <baseLoader v-if="paginaLoader"></baseLoader>
    <div v-if="answerIdTerminale !== null" :class="rispostaTerminaleInfosClass">
      <div class="row w-100">
        <div class="col-12" align="center">
          <div style="max-width: 1155px">
            <div v-if="true" class="row w-100"></div>
            <div v-if="renderTicketComponent  && !isInHoliday" class="row w-100">
              <ticket
                :answerId="answerIdTerminale"
                :surveyId="surveyId"
                :staticAnswerShowInput="true"
                :setPaginaLoaderCallback="setPaginaloaderCallback"
                :getPaginaRingraziamentoCallback="
                  getPaginaRingraziamentoCallback
                "
                :staticAnswerShowInputElements="staticAnswerShowInputElements"
              ></ticket>
            </div>
            <div id="question-pre-ticket">
              <div v-if="!renderTicketComponent" class="row w-100">
                <div
                  class="question-pre-ticket-opening w-100 d-flex align-items-center"
                  v-if="renderQuestion"
                >
                  <div class="textarea-pre-ticket w-100">
                    <customTextArea
                      :labelKey="'question-custom'"
                      :inputId="'question-custom'"
                      :required="true"
                      :ref="'question-pre-ticket'"
                    >
                      <template v-slot:subLabel>
                        <div>
                          <strong>IMPORTANTE</strong>: si informa che ai fini di
                          una efficiente gestione del servizio si darà risposta
                          in via prioritaria ai quesiti posti in modo esaustivo.
                        </div>
                      </template>
                      <template v-slot:nextTextarea>
                        <button
                          class="invia-domanda float-start btn btn-lg"
                          :onClick="inviaDomandaClick"
                        >
                          Invia
                        </button>
                      </template>
                    </customTextArea>
                  </div>
                </div>
                <div :class="arrticoliJoomlaLayoutClassname">
                  <articoliJoomla
                    :answerId="answerIdTerminale"
                    :showTitle="false"
                    :onLoadDataEnded="onArticoliJoomlaLoadDataEnded"
                    :onLoadDataStarted="onArticoliJoomlaLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></articoliJoomla>
                </div>
                <div :class="documentiUtiliLayoutClassname">
                  <documentiUtili
                    :answerId="answerIdTerminale"
                    :onLoadDataEnded="onResourcesLoadDataEnded"
                    :onLoadDataStarted="onResourceLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></documentiUtili>
                </div>
                <div :class="faqLayoutClassname">
                  <faq
                    :answerId="answerIdTerminale"
                    :onLoadDataEnded="onFaqLoadDataEnded"
                    :onLoadDataStarted="onFaqLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                  ></faq>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="questionario-content-container col-12" align="center">
        <checkTicketActivation
          :setPaginaLoaderCallback="setPaginaloaderCallback"
          :onRicominciaQuestionarioClickCallback="onRicominciaQuestionarioClickCallback"
        >
          <questionario
            v-if="$store.state.userIsLoggedIn"
            :key="$store.state.userIsLoggedIn"
            :saveAnswerHistoryMode="
              $store.state.libraryWiperConfig.ricordaRisposteQuestionario
            "
            ref="questionarioRef"
            :surveyId="surveyId"
            :paginaLoader="paginaLoader"
            :rispostaTerminaleCallback="rispostaTerminaleCallback"
            :rispostaCallback="rispostaCallback"
            :onIndietroClickCallback="onIndietroClickCallback"
            :onRicominciaQuestionarioClickCallback="
              onRicominciaQuestionarioClickCallback
            "
            :rispostaFinaleCallback="rispostaFinaleCallback"
            :setPaginaLoaderCallback="setPaginaloaderCallback"
            :onCreateSurveyLogCallback="onCreateSurveyLogCallback"
            :paginaRingraziamentoAperta="paginaRingraziamentoAperta"
          />
      </checkTicketActivation>
      </div>
    </div>
    <modalInbound />
  </div>
</template>

<script>
import Questionario from "../questionario/Questionario.vue";
import Faq from "../contenitoreFaq/Faq.vue";
import DocumentiUtili from "../documentiUtili/DocumentiUtili.vue";
import ArticoliJoomla from "../articoloJoomla/ArticoliJoomla.vue";
import TextArea from "../formInputs/textArea/TextArea.vue";
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue";
import TicketDinamico from "../ticket/TicketDinamico.vue";
import CheckTicketActivation from "../checkActivationTicket/CheckTicketActivation.vue";
import ModalInbound from "../modalInbound/ModalInbound.vue"
export default {
  name: "pagina-questionario",
  components: {
    questionario: Questionario,
    faq: Faq,
    documentiUtili: DocumentiUtili,
    ticket: TicketDinamico,
    baseLoader: BaseLoader,
    customTextArea: TextArea,
    articoliJoomla: ArticoliJoomla,
    checkTicketActivation: CheckTicketActivation,
    modalInbound: ModalInbound
  },
  props: {
    surveyId: {
      type: Number,
      default: process.env.VUE_APP_SURVEY_ID_1,
    },
  },

  data: function () {
    return {
      answerIdTerminale: null,
      renderFaqComponent: true,
      faqComponentDataLoaded: false,

      documentiUtiliComponentDataLoaded: false,
      renderDocumentiUtiliComponent: true,

      articoliJoomlaComponentDataLoaded: false,
      renderArticoliJoomlaComponent: true,

      renderTicketComponent: false,
      renderQuestion: false,
      childLoaders: {},
      staticAnswerShowInputElements: [
        {
          required: true,
          name: "question",
          defaultValue: "",
        
        },
        {
          required: true,
          name: "name",
        },
        {
          required: true,
          name: "surname",
        },
        {
          required: false,
          name: "mobile",
          pattern: "[0-9]+",
        },
        {
          required: false,
          name: "telefon",
          pattern: "[0-9]+",
        },
        {
          required: false,
          name: "contact_times",
        },
        {
          required: true,
          name: "pec_or_peo_email",
        },
      ],
      paginaQuestionarioLoader: false,
      paginaRingraziamentoAperta: false,
    };
  },
  methods: {
    // metodo scatenato al click del bottone 'invia' sulla textarea della domanda prima di entrare nel ticket.
    // fa comparire il ticket e modifica il valore di default che arriverà alla domanda nel ticket.
    inviaDomandaClick() {
      let questionElement = this.staticAnswerShowInputElements.find(
        (item) => item.name === "question"
      );
      if (questionElement) {
        let defaultValueDomanda = this.$refs["question-pre-ticket"].inputField;
        if (defaultValueDomanda) {
          questionElement.defaultValue = defaultValueDomanda;
        }
      }
      this.renderTicketComponent = true;
      this.renderQuestion = false;
      this.$refs.questionarioRef && this.$refs.questionarioRef.addFakeAnswer();
    },
    async closeSurveyLog() {
      await this.$refs.questionarioRef?.closeSurveyLog();
    },
    setPaginaloaderCallback(value) {
      this.childLoaders = { ...this.childLoaders, ...value };
    },
    getPaginaRingraziamentoCallback(paginaRingraziamentoAperta) {
      this.paginaRingraziamentoAperta = paginaRingraziamentoAperta;
    },
    rispostaTerminaleCallback(response, answerInfo) {
      if (answerInfo.id) {
        this.answerIdTerminale = answerInfo.id;
      }
    },
    rispostaCallback(response, answerInfo) {
      this.answerIdTerminale = null;
    },
    nascondiDomandaRisposte() {
      var domandeRisposte = document.getElementsByClassName('domanda-e-risposte');
        for (var i = 0; i < domandeRisposte.length; i++) {
          domandeRisposte[i].style.display = 'none';
        }
    },
    mostraDomandaRisposte() {
      var domandeRisposte = document.getElementsByClassName('domanda-e-risposte');
        for (var i = 0; i < domandeRisposte.length; i++) {
          domandeRisposte[i].style.display = 'block';
        }
    },
    rispostaFinaleCallback(type) {
      switch (type) {
        case "wiper-amministrativo-foglia":
          this.renderTicketComponent = true
          this.renderQuestion = false
          break;
        case "wiper-assistenza-no":
          this.renderQuestion = true;
          this.nascondiDomandaRisposte()
          var elemento = document.getElementById("question-pre-ticket");

          // Scopri la sua posizione rispetto alla finestra
          var posizione = elemento.getBoundingClientRect().top -50;

          // Esegui lo scroll
          window.scrollTo({
            top: posizione + window.scrollY,
            behavior: "smooth", // Opzionale, rende lo scorrimento fluido
          });
          this.renderQuestion = true;

          break;
        case "wiper-assistenza-yes":
        this.mostraDomandaRisposte()
          if (this.$store.hasModule("questionarioStore-" + this.surveyId)) {
            this.$store.commit(
              "questionarioStore-" + this.surveyId + "/doResetQuiz"
            );
          }
          if(this.$store?.state?.libraryWiperConfig?.lastSurveyLocalstorageId){
            localStorage.removeItem(
              this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId
            );
          }
          
          if (this.assistenzaPortaleBaserl) {
            window.location.href = this.assistenzaPortaleBaserl;
          }
          return null;
        default:
          return null;
      }
    },

    onIndietroClickCallback() {
      this.mostraDomandaRisposte()
      this.answerIdTerminale = null;
      this.renderQuestion = false;
      this.renderTicketComponent = false;
    },
    onRicominciaQuestionarioClickCallback() {
      this.mostraDomandaRisposte()
      this.renderQuestion = false
      this.paginaRingraziamentoAperta = false;
      this.answerIdTerminale = null;
    },

    onCreateSurveyLogCallback() {
      this.renderTicketComponent = false;
    },
    onArticoliJoomlaLoadDataEnded(response, articoli) {
      if (articoli && articoli.length > 0) {
        this.renderArticoliJoomlaComponent = true;
      } else {
        this.renderArticoliJoomlaComponent = false;
      }
    },
    onFaqLoadDataEnded(response, faqs) {
      if (faqs && faqs.length > 0) {
        this.renderFaqComponent = true;
      } else {
        this.renderFaqComponent = false;
      }
      this.faqComponentDataLoaded = true;
    },
    onResourcesLoadDataEnded(response, documenti) {
      if (documenti && documenti.length > 0) {
        this.renderDocumentiUtiliComponent = true;
      } else {
        this.renderDocumentiUtiliComponent = false;
      }
      this.documentiUtiliComponentDataLoaded = true;
    },
    onResourceLoadDataStarted() {
      this.renderDocumentiUtiliComponent = false;
      this.documentiUtiliComponentDataLoaded = false;
    },
    onFaqLoadDataStarted() {
      this.renderFaqComponent = false;
      this.faqComponentDataLoaded = false;
    },
    onArticoliJoomlaLoadDataStarted() {
      this.renderArticoliJoomlaComponent = false;
      this.articoliJoomlaComponentDataLoaded = false;
    },
  },
  watch: {
    async renderTicketComponent(newValue, oldValue) {
      if(newValue === true && oldValue === false && this.isInHoliday){
        if(this.$store.state.libraryWiperConfig?.urlChiusoPerFerie?.startsWith('/') ){
          await this.closeSurveyLog()
          window.location.href = this.$store.state.libraryWiperConfig.urlChiusoPerFerie
        }
      }
    },
    /* renderQuestion(newValue,oldValue){
      if(newValue === true && oldValue === false){
        this.nascondiDomandaRisposte()
      }else if(newValue === false && oldValue === true){
        this.mostraDomandaRisposte()
      }
    } */
 
  },
  computed: {
    assistenzaPortaleBaserl: function () {
      return process.env.VUE_APP_URL_ASSISTENZA_PORTALE || null;
    },
    isInHoliday(){
      let isInHoliday = false
      if(this.$store.state.libraryWiperConfig.chiusoPerFerie === "SI"){
        let ferieDal = this.$store.state.libraryWiperConfig.chiusoPerFerieDal
        let ferieAl = this.$store.state.libraryWiperConfig.chiusoPerFerieAl
        
        if(!ferieAl && !ferieDal){
          isInHoliday = true
        }else{
          let today = new Date()
          if(ferieDal && ferieAl){
            isInHoliday = today >= new Date(ferieDal) && today <= new Date(ferieAl)
          }else if(ferieDal){
            isInHoliday = today >= new Date(ferieDal)
          }else if(ferieAl){
            isInHoliday = today <= new Date(ferieAl)
          }
        }
      }
      return isInHoliday
    },

    paginaLoader: function () {
      let loaders = Object.keys(this.childLoaders);
      let paginaLoader = false;
      if (this.paginaQuestionarioLoader === true) {
        paginaLoader = true;
      } else if (loaders.length > 0) {
        loaders.map((loader) => {
          if (this.childLoaders[loader] === true) {
            paginaLoader = true;
          }
        });
      }
      return paginaLoader;
    },
    paginaQuestionarioClass: function () {
      if (this.showTicket) {
        return "pagina-questionario ticket";
      }
      return "pagina-questionario";
    },
    rispostaTerminaleInfosClass: function () {
      if (
        this.faqComponentDataLoaded &&
        this.documentiUtiliComponentDataLoaded
      ) {
        return "risposta-terminale-container-info visible";
      } else if (this.renderTicketComponent) {
        return "risposta-terminale-container-info visible";
      }
      return "risposta-terminale-container-info invisible";
    },
    paginaQuestionarioClassName: function () {
      if (this.renderTicketComponent) {
        return "pagina-questionario hide-questions ticket-on";
      }
      return "pagina-questionario";
    },
    arrticoliJoomlaLayoutClassname: function () {
      if (this.renderArticoliJoomlaComponent) {
        return "col-12";
      }
      return "col-0";
    },
    documentiUtiliLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-4";
      }
      if (!this.renderDocumentiUtiliComponent) {
        return "col-0";
      }
      if (this.renderDocumentiUtiliComponent && !this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
    faqLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-8";
      }
      if (!this.renderFaqComponent) {
        return "col-0";
      }
      if (!this.renderDocumentiUtiliComponent && this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
  },
};
</script>
